import axios from 'axios'
export default class LalService {
  constructor(endpoint = process.env.REACT_APP_LAL_ENDPOINT) {
    this.endpoint = endpoint;
  }

  async getAllApplications() {
    const URL = `${this.endpoint}/list`
    const response = await axios.get(URL)
    return response.data
  }

  async getAllRecentlyCreatedUsers() {
    const URL = `${this.endpoint}/user/list/recent`
    const response = await axios.get(URL)
    return response.data
  }

  async getAllUsers() {
    const URL = `${this.endpoint}/user/list`
    const response = await axios.get(URL)
    return response.data
  }

  async updateUserRole(user) {
    await axios.put(`${this.endpoint}/user`, { email: user._id, role: user.role })
  }

  async deleteUser(user) {
    await axios.request({url: `${this.endpoint}/user`, data: { email: user._id }, method: 'delete' })
  }

  async registerUser(user) {
    await axios.post(`${this.endpoint}/user`, { username: user._id, password: user.password, role: user.role })
  }

  async getUserLoginAudit() {
    const URL = `${this.endpoint}/user/audit/login`
    const response = await axios.get(URL)
    return response.data
  }

  async getAllMnoContacts() {
    const response = await axios.get(`${this.endpoint}/mno/contact`)
    return response.data
  }

  async createMnoContact(contact) {
    await axios.post(`${this.endpoint}/mno/contact`, contact)
  }

  async updateMnoContact(contact) {
    await axios.put(`${this.endpoint}/mno/contact`, contact)
  }

  async deleteMnoContact(contact) {
    await axios.request({url: `${this.endpoint}/mno/contact`, data: { email: contact.email }, method: 'delete' })
  }
}
